import { render, staticRenderFns } from "./countrySelector.vue?vue&type=template&id=670a3914"
import script from "./countrySelector.vue?vue&type=script&lang=js"
export * from "./countrySelector.vue?vue&type=script&lang=js"
import style0 from "./countrySelector.vue?vue&type=style&index=0&id=670a3914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports